import { render, staticRenderFns } from "./AscPlotsGrid.vue?vue&type=template&id=64a2ec02&scoped=true&"
import script from "./AscPlotsGrid.vue?vue&type=script&lang=js&"
export * from "./AscPlotsGrid.vue?vue&type=script&lang=js&"
import style0 from "./AscPlotsGrid.vue?vue&type=style&index=0&id=64a2ec02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a2ec02",
  null
  
)

export default component.exports